// Admin "Affiliates" tab — every affiliate in the portal + their outreach board.
import { useEffect, useState } from "react";
import { axiosInstance } from "../../config";
import toast from "react-hot-toast";

function rel(d) {
  if (!d) return "—";
  const s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60); if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60); if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

function AffiliateRow({ a }) {
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState(null);
  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && !detail) {
      try {
        const r = await axiosInstance.get(`/admin/affiliates/${a.id}`);
        setDetail(r.data.affiliate);
      } catch { toast.error("Couldn't load board"); }
    }
  };
  return (
    <div className="aff-row-wrap">
      <div className="aff-row" onClick={toggle}>
        <div className="aff-row-id">
          <div className="aff-name">{a.name || "(no name)"}</div>
          <div className="aff-email muted">{a.email || "—"}</div>
        </div>
        <div className="aff-nums">
          <span title="DMs sent"><b>{a.stats.sent}</b> sent</span>
          <span title="Replies"><b>{a.stats.replied}</b> replies</span>
          <span title="Reply rate"><b>{a.stats.replyRate}%</b></span>
          <span title="Signed up" className="aff-signed"><b>{a.stats.signed}</b> signed</span>
        </div>
        <span className="muted aff-when">{rel(a.lastActiveAt || a.createdAt)}</span>
      </div>
      {open && detail && (
        <div className="aff-detail">
          {(detail.contacts || []).length === 0 ? (
            <div className="admindash-empty">No contacts logged yet.</div>
          ) : (
            detail.contacts.map((c) => (
              <div key={c.cid} className="aff-contact">
                <span className="aff-contact-name">{c.name}</span>
                <span className="muted">{c.platform} · {c.dateSent}</span>
                <span className="aff-flags">
                  {c.replied && <em>replied</em>}
                  {c.demoViewed && <em>demo</em>}
                  {c.followupSent && <em>follow-up</em>}
                  {c.signedUp && <em className="won">signed up</em>}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default function AffiliatesTab() {
  const [data, setData] = useState(null);
  useEffect(() => {
    axiosInstance.get("/admin/affiliates").then((r) => setData(r.data)).catch((e) => {
      toast.error(e.response?.data?.error || "Failed to load affiliates");
      setData({ affiliates: [], totals: {} });
    });
  }, []);

  if (!data) return <div className="admindash-empty admindash-shimmer">Loading…</div>;
  const { affiliates = [], totals = {} } = data;

  return (
    <div className="admindash-section admindash-fade-in">
      <h2 className="admindash-section-title">
        Affiliates <span className="muted">({totals.affiliates || 0})</span>
      </h2>
      <div className="muted" style={{ fontSize: 13, marginBottom: 16 }}>
        {totals.sent || 0} DMs sent · {totals.replied || 0} replies · <b>{totals.signed || 0}</b> signed up across all affiliates
      </div>
      {affiliates.length === 0 ? (
        <div className="admindash-empty">
          No affiliates yet. Share <b>app.clipbait.ai/affiliates</b> + the access password to recruit.
        </div>
      ) : (
        <div className="aff-list">
          {affiliates.map((a) => <AffiliateRow key={a.id} a={a} />)}
        </div>
      )}
    </div>
  );
}
